<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="视频id" prop="videoId" >-->
<!--        <a-input v-model="form.videoId" placeholder="请输入视频id" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="演员姓名" prop="performerName" >
        <a-input v-model="form.performerName" placeholder="请输入演员姓名" />
      </a-form-model-item>
      <a-form-model-item label="演员头像" prop="performerAvatar" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.performerAvatar"
          :showUploadList="false"
          :customRequest="handleChange"
        >
          <img v-if="form.performerAvatar" :src="form.performerAvatar" alt="logo"
               style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort" >
        <a-input-number :min="0" :precision="0" v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
<!--      <a-form-model-item label="是否禁用 0-否 1-是" prop="isBan" >-->
<!--        <a-input v-model="form.isBan" placeholder="请输入是否禁用 0-否 1-是" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入备注" />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideoPerformer, addVideoPerformer, updateVideoPerformer } from '@/api/videoPerformer/videoPerformer'
import UploadFileToVOD from "@/api/vod";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      videoId: null,
      // 表单参数
      form: {
        id: null,

        videoId: null,

        performerName: null,

        performerAvatar: null,

        sort: null,

        isBan: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        videoId: null,
        performerName: null,
        performerAvatar: null,
        sort: null,
        isBan: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (videoId) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.form.videoId = videoId
      this.videoId = videoId
      console.log(this.videoId)
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids,videoId) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideoPerformer({"id":id}).then(response => {
        this.form = response.data
        this.form.videoId = videoId
        this.videoId = videoId
        console.log(this.videoId)
        this.open = true
        this.formTitle = '修改'
      })
    },

    handleChange(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log(fileName)
          that.form.performerAvatar = fileName[0];//文件名
          console.log(11111111111111111)
          console.log(this.form.performerAvatar)
          that.uploadLoading = false;
        }
      });
      that.uploadLoading = false;
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(11111111111)
      console.log(this.videoId)

      this.form.videoId=this.videoId
      console.log(this.form)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            this.form.videoId=this.videoId
            updateVideoPerformer(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            this.form.videoId=this.videoId
            console.log(this.form)
            console.log(this.videoId)
            addVideoPerformer(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
